class MenuRoles{
  //produccion
  static menu = {
    'roles':'/AdministracionRoles',
    'usuarios':'/AdministracionUsuarios',
    'tokens':'/AdministracionTokens',
    'existencias':'/Existencias',
    'pedidos': '/Pedidos',
    'pedidosInternos': '/PedidosInternos'
  }
}

export default MenuRoles;
